export default {"src":"https://fishbrain.com/_next/static/media/evening.ae221b24.svg","height":44,"width":64,"blurWidth":0,"blurHeight":0};